<template>
    <div class="home">
        <Navbar />
        <div class="main-box">
            <img src="../assets/index/main.jpg">
            <img src="../assets/index/logo_text.png">
            <img src="../assets/index/btn_learnmore.png" @click="showVideo()">
        </div>
        <div class="md-img">
            <img src="../assets/index/bg-text.jpg">
            <img src="../assets/index/text-img.png">
            <router-link to="/company">ABOUT US ></router-link>
        </div>
        <div id="products"></div>
        <div class="products">
            <h3>PRODUCTS</h3>
            <div class="products-list">
                <div class="list-text">
                    <img src="../assets/index/icon-1.png">
                    <h4>Car Configurator</h4>
                    <p>3D visualized car configurator for dealer installation and mobile. Capable for real-time cloud stream interaction.</p>
                    <router-link to="/carConfigurator"><img src="../assets/index/more.png"></router-link>
                </div>
                <div class="list-img"><img src="../assets/index/products-1.jpg"/></div>
            </div>
            <div class="products-list">
                <div class="list-img"><img src="../assets/index/products-2.jpg"/></div>
                <div class="list-text">
                    <img src="../assets/index/icon-2.png">
                    <h4>Mobile Smart Car<br/>Sales Assistance</h4>
                    <p>Fast-to-use mobile sales product to connect customer to sales people. Capable for real-time streaming and social media applications</p>
                    <router-link to="/mobileSmartCar"><img src="../assets/index/more.png"></router-link>
                </div>
            </div>
            <div class="products-list">
                <div class="list-text">
                    <img src="../assets/index/icon-3.png">
                    <h4>Real-time 3D Asset<br/>Visualization</h4>
                    <p>Real-time 3D asset management platform to fast generate visualized content for different usages (R&D, design, marketing, etc.,) </p>
                    <router-link to="/realTime3d"><img src="../assets/index/more.png"></router-link>
                </div>
                <div class="list-img"><img src="../assets/index/products-3.jpg"/></div>
            </div>
            <div class="products-list">
                <div class="list-img"><img src="../assets/index/products-2.jpg"/></div>
                <div class="list-text">
                    <img src="../assets/index/icon-2.png">
                    <h4>Auto Drive <br/>Content Platform</h4>
                    <p>Real-time 3D environment asset building and management product. Simulation and data collection for L3 to L5 autonomous driving and smart city management.</p>
                    <router-link to="/autoDrive"><img src="../assets/index/more.png"></router-link>
                </div>
            </div>
            <div class="products-list">
                <div class="list-text">
                    <img src="../assets/index/icon-5.png">
                    <h4>VR & AR Innovation</h4>
                    <p>VR and AR interactive technology and 3D visualization for R&D, design collaboration, training, experience and sales assistance</p>
                    <router-link to="/VR&AR"><img src="../assets/index/more.png"></router-link>
                </div>
                <div class="list-img"><img src="../assets/index/products-5.jpg"/></div>
            </div>
        </div>
        <div class="projects">
            <h3>PROjects</h3>
            <div class="projects-list">
              <div class="projects-box">
                  <h4>Volkswagen Touareg Dealer Car Configurator</h4>
                  <video class="video-js vjs-default-skin vjs-big-play-centered vjs-16-9 vjs-fluid" preload="auto"
                      poster="../../public/img-cover/carConfigurator/volkswagen_visualiser.jpg">
                      <source src="../../public/video/carConfigurator/volkswagen_visualiser.mp4" type='video/mp4' />
                  </video>
              </div>
              <div class="projects-box">
                  <h4>ADAS/AD Simulation Content Platform</h4>
                  <video  class="video-js vjs-default-skin vjs-big-play-centered vjs-16-9 vjs-fluid" 
                      poster="../../public/img-cover/autoDriveContentPlatform/gasStation.jpg">
                      <source src="../../public/video/autoDriveContentPlatform/gasStation.mp4" type='video/mp4' />
                  </video>
              </div>
              <div class="projects-box">
                  <h4>Audi RS6 VR Clinic System</h4>
                  <video class="video-js vjs-default-skin vjs-big-play-centered vjs-16-9 vjs-fluid" preload="auto"
                      poster="../../public/img-cover/ar&vr/Audi_RS6_VR.jpg">
                      <source src="../../public/video/ar&vr/audi_RS6_VR.mp4" type='video/mp4' />
                  </video>
              </div>
            </div>
            <div class="projects-all">
                <router-link to="/projects">All Projects ></router-link>
            </div>
        </div>
        <div class="brand" id="brandExperience">
            <h3>CUSTOMERS</h3>
            <p>Thanks to our expertise in visualization and interactive technologies, we help our client build innovative and connected <br/> marketing and sales experience, and sustain a stable and partnership with world’s leading car brands.</p>
        </div>
        <swipe class="swipe-brand swiper-no-swiping" :speed="500" :auto="4200" :disabled="true">
            <swipe-item class="slide1"><img src="../assets/index/swipe-1-1.jpg"></swipe-item>
            <swipe-item class="slide2"><img src="../assets/index/swipe-1-2.jpg"></swipe-item>
        </swipe>
        <div class="partner" id="brandPartner">
            <h3>PARTNERS</h3>
            <p>Relationships with different partners ensure that ONESTEP is able to obtain the latest technology and market demand.</p>
        </div>
        <div class="partner-container">
          <img src="../assets/index/partners.jpg">
        </div>
        <swipe class="swipe-address swiper-no-swiping" :speed="500" :auto="5200" :disabled="true">
            <swipe-item class="slide1"><img src="../assets/index/swipe-2-1.jpg"></swipe-item>
            <swipe-item class="slide2"><img src="../assets/index/swipe-2-2.jpg"></swipe-item>
        </swipe>

        <transition name="fade">
          <div class="content-wrapper" v-if= "toogleVideo" >
              <div class="video-box">
                  <img src="../assets/common/icon-close.png" @click="closeVideo()" />
                  <video id="mainVideo"  controls autoplay preload="auto"  poster="../../public/img-cover/all_mix_clip.jpg">
                      <source src="../../public/video/all_mix_clip.mp4" type='video/mp4' />
                  </video>
              </div>
          </div>
        </transition>
        <GoTop/>
        <Footer />
    </div>
</template>

<script>
import $ from 'jquery'
import Navbar from '@/components/Navbar.vue'
import Footer from '@/components/Footer.vue'
import GoTop from '@/components/GoTop.vue'

export default {
  name: 'Home',
  components: {
    Navbar,
    Footer,
    GoTop
  },
  data () {
    return {
      toogleVideo: false,
      isPlay:true
    }
  },
  methods: {
    showVideo () {
      this.toogleVideo = true
    },
    closeVideo () {
      this.toogleVideo = false
      mainVideo.pause()
    },
    initVideo() {
      const videos = document.getElementsByTagName('video');
      for(var i=0; i<videos.length; i++) {
        let myPlayer = this.$video(videos[i], {
            controls: true
        });
      }
    },
    videoStatus() {
      var elevideo = document.getElementsByTagName("video");
      for(var i = 0; i< elevideo.length; i++){
        elevideo[i].addEventListener('playing', function () { //播放中
          var this1=this;
          this.play();
          for(var b=0;b<elevideo.length;b++){
            var this2=elevideo[b];
            if(this1!==this2){
                this2.pause();
                this2.currentTime = 0
                this2.load();
            }
          }
        });
        
        elevideo[i].addEventListener('ended', function () { 
          this.load()
        })
    }
    }
  },
  mounted () {
    var hash = window.location.hash
    var index = hash.lastIndexOf('#')
    if (index !== -1) {
      var id = hash.substring(index + 1, hash.length + 1)
      var div = document.getElementById(id)
      if (div) {
        setTimeout(function () {
          $('html, body').animate({ scrollTop: $(div).offset().top - 43 }, 500)
        }, 500)
      }
    }
    this.initVideo()
    this.videoStatus()
  }
}
</script>

<style lang="stylus" scoped>
@import '../style/common'
.main-box
  width 100%
  text-align center
  position relative
  img
    display block
  img:nth-of-type(1)
    width 100%
  img:nth-of-type(2)
    width 30%
    position absolute
    left 50%
    top 50%
    z-index 2
    -webkit-transform: translate(-50%,-50%);
    -moz-transform: translate(-50%,-50%);
    transform:translate(-50%,-50%);
  img:nth-of-type(3)
    width 12%
    margin 7rem auto 0 auto
    position absolute
    z-index 3
    cursor pointer
    left 50%
    top 56%
    -webkit-transform: translate(-50%,-50%);
    -moz-transform: translate(-50%,-50%);
    transform:translate(-50%,-50%);
.md-img
    width 100%
    position relative
    img
      display block
    img:nth-of-type(1)
      width 100%
    img:nth-of-type(2)
      width 40%
      position absolute
      left 50%
      top 50%
      z-index 2
      -webkit-transform: translate(-50%,-50%);
      -moz-transform: translate(-50%,-50%);
      transform:translate(-50%,-50%);
    a
      color #11A9FB
      font-size 1.6rem
      position absolute
      top 80%
      left 50%
      z-index 2
      -webkit-transform: translate(-50%,-50%);
      -moz-transform: translate(-50%,-50%);
      transform:translate(-50%,-50%);
      text-decoration none
#products
    padding-top 5rem
    background #000
.products
    background #000
    text-align center
    h3
      font-size 3rem
      font-weight 500
      color #fff
      padding-bottom 3rem
      text-transform uppercase
    .products-list
        display flex
        flex-flow row nowrap
        align-items center
        .list-text
            width 50%
            img:nth-of-type(1)
              width 8rem
              margin 0
              padding 0
            h4
              font-size 2rem
              color #fff
              word-break keep-all
              word-wrap break-word
              white-space pre-wrap
              padding 1rem 5rem
            p
              color #B4B4B4
              font-size 1.4rem
              word-break keep-all
              word-wrap break-word
              white-space pre-wrap
              padding 0rem 5rem 1rem 5rem
            img:last-child
              width 5rem!important
              cursor pointer
        .list-img
            width 50%
            padding 0
            margin 0
            img
              width 100%
              padding 0
              margin-bottom -4px
.projects
    background #000
    text-align center
    padding-top 10rem
    h3
      font-size 3rem
      font-weight 500
      color #fff
      padding-bottom 3rem 
      text-transform uppercase
    .projects-list
      width 100%
      display flex
      justify-content space-between
      flex-flow row nowrap
      .projects-box
        width 33%
        padding 2rem 2rem
        h4
          font-size 1.2rem
          color #fff
          margin-bottom 1.5rem
          font-weight 400
        video
          width 100%
    .projects-all
        text-align right
        padding 2rem 2rem 2rem 0
        a
          font-size 1.2rem
          color #11A9FB
          text-decoration none
.brand
  text-align center
  padding-top 10rem
  h3
    font-size 3rem
    font-weight 500
    color #000
  p
    color #212121
    font-size 1.2rem
    margin-top 1rem

.partner
  text-align center
  padding-top 10rem
  h3
    font-size 3rem
    font-weight 500
    color #000
  p
    color #212121
    font-size 1.2rem
    margin-top 1rem

.partner-container
  background-color #fff
  display flex
  justify-content center
  img
    height 38rem

.swipe-brand
  height 30rem
  text-align center
  .slide1
    background-color #fff
    img
      height 30rem
      margin 0 -100rem
  .slide2
    background-color #fff
    img
      height 30rem
      margin 0 -100rem
.swipe-address
    height 36rem
    text-align center
    margin-top 8rem
    .slide1
      background-color #fff
      img
        height 36rem
        margin 0 -100rem
    .slide2
      background-color #fff
      img
        height 36rem
        margin 0 -100rem
/deep/ .mint-swipe-indicators
    .mint-swipe-indicator
        width 1rem
        height 1rem
        background #B4B4B4!important
    .is-active
        background #5F5F5F!important

/** 滚动条样式 **/
/deep/ .__bar-is-vertical
    right -1px !important

::-webkit-scrollbar
  width 5px
/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track
  border-radius 10px
  background-color rgba(0,0,0,0.1)
/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb
  border-radius 10px
  -webkit-box-shadow inset 0 0 6px rgba(0,0,0,.3)
  background-color rgba(0,0,0,0.1)

.content-wrapper
  background-color rgba(black, .4)
  background-size 100% auto
  background-repeat no-repeat
  background-position-y -18vw
  position fixed
  top 0
  bottom 0
  left 0
  right 0
  z-index 5
  .video-box
    width 50%
    position absolute
    top 50%
    left 50%
    -webkit-transform translate(-50%,-50%)
    -moz-transform translate(-50%,-50%)
    transform translate(-50%,-50%)
    img
      width 3rem
      position absolute
      right -.5rem
      top -3rem
      cursor pointer
    video
      width 100%
      &:focus
        outline none
</style>
